import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const money = (v) => (v == null || v === "" ? "—" : `$${Number(v).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

// Live breakdown; values are calculated by the backend (authoritative Decimal maths).
export function RateBreakdown({ gross, fee, effectiveFrom, testId = "rate-breakdown" }) {
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!gross || isNaN(Number(gross))) return setR(null);
    const t = setTimeout(() => {
      api.post("/rates/preview", { gross_rate: String(gross), payme_fee_percent: fee ? String(fee) : "0", effective_from: effectiveFrom || null })
        .then((res) => { setR(res.data); setErr(""); })
        .catch((e) => { setR(null); setErr(e?.response?.data?.detail || "Can't calculate"); });
    }, 250);
    return () => clearTimeout(t);
  }, [gross, fee, effectiveFrom]);

  if (err) return <p className="text-xs text-red-600" data-testid={`${testId}-error`}>{String(err)}</p>;
  if (!r) return <p className="text-xs text-slate-400">Enter a gross rate to see the breakdown.</p>;
  const rows = [["Gross rate", r.gross_rate, "text-slate-900"], [`PayMe fee (${fee || 0}%)`, `-${r.payme_fee}`, "text-slate-600"],
    [`Super (${r.super_guarantee_percent}% SG)`, `-${r.super_amount}`, "text-slate-600"]];
  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50/60 p-4" data-testid={testId}>
      {rows.map(([l, v, c]) => (
        <div key={l} className="flex justify-between text-sm py-0.5"><span className="text-slate-500">{l}</span><span className={`font-mono ${c}`}>{v.startsWith("-") ? `−${money(v.slice(1))}` : money(v)}</span></div>
      ))}
      <div className="flex justify-between border-t border-blue-200 mt-2 pt-2">
        <span className="text-sm font-semibold text-slate-800">Taxable rate</span>
        <span className="font-mono font-bold text-blue-700" data-testid={`${testId}-taxable`}>{money(r.taxable_rate)}</span>
      </div>
    </div>
  );
}

export { money };
